import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getAuthService } from '@asd-stan/auth/infrastructure/getters';
import { Button } from '@asd-stan/ui-kit/components/button/button';
import { Formik } from 'formik';
import {
    StyledPrivacyPolicyCheckMarkWrapper,
    StyledPrivacyPolicyDescription,
    StyledPrivacyPolicyTitle
} from "@asd-stan/auth/components/privacy-policy/privacy-policy.styled";
import { PrivacyPolicyLayout } from "@asd-stan/auth/components/layout/privacy-policy-layout/privacy-policy-layout";
import { ReactComponent as CheckMark } from './assets/check-mark.svg';

export const PrivacyPolicy: React.FC = observer(() => {
    const { t } = useTranslation();

    const navigate = useNavigate();
    const authService = getAuthService();

    const [loadingRequest, setLoadingRequest] = useState(false);

    const onSubmit = async () => {
        try {
            setLoadingRequest(true);
            await authService.confirmPrivacyPolicy();
            setLoadingRequest(false);
            navigate('/dashboard');
        } catch (error) {
            console.log(error);
            setLoadingRequest(false);
        }
    };

    return (
        <Formik
            initialValues={{}}
            onSubmit={onSubmit}>
            {({ handleSubmit }) => (
                <PrivacyPolicyLayout>
                    <StyledPrivacyPolicyCheckMarkWrapper>
                        <CheckMark/>
                    </StyledPrivacyPolicyCheckMarkWrapper>
                    <StyledPrivacyPolicyTitle>
                        {t('auth.privacyPolicy.title')}
                    </StyledPrivacyPolicyTitle>
                    <StyledPrivacyPolicyDescription className="spacing">
                        <Trans
                            i18nKey='auth.privacyPolicy.description1'
                            components={[
                                <a href='https://asd-stan.org/en/info/rules-and-policy-documents' target='_blank'/>
                            ]}
                        />
                    </StyledPrivacyPolicyDescription>
                    <StyledPrivacyPolicyDescription className="spacing">
                        <Trans
                            i18nKey='auth.privacyPolicy.description2'
                            components={[
                                <a href='https://asd-stan.org/en/info/rules-and-policy-documents' target='_blank'/>
                            ]}
                        />
                    </StyledPrivacyPolicyDescription>
                    <StyledPrivacyPolicyDescription className="spacing">
                        <Trans
                            i18nKey='auth.privacyPolicy.description3'
                            components={[
                                <span/>
                            ]}
                        />
                    </StyledPrivacyPolicyDescription>
                    <Button
                        title={t('auth.privacyPolicy.submitBtn')}
                        onClick={handleSubmit}
                        disabled={loadingRequest}
                        fullWidth
                    />
                </PrivacyPolicyLayout>
            )}
        </Formik>
    );
});
